export default __webpack_public_path__ + "d394e6c7900e39ee09a566e898d569c5.png";